module.exports = __webpack_public_path__ + "img/qrcode-box.bc309aa8.png";